import moment from "moment";
import Settings from "../constants/Settings";

export class FinalPayment {
    StaffID;
    StaffName;
    Dept;
    Title;
    YOS;
    DateJoin;
    LastWorkingDate;
    AnnualLeave;
    CompensationLeave;
    AnnualLeaveTotal;
    CompensationLeaveTotal;
    AnnualLeaveMEP;
    CompensationLeaveMEP;
    EmployType;
    PayType;
    Salary;
    AtuSalary;
    DailyRate;
    LessMPF;
    salaryAdjs;
    constructor() {
        this.StaffID = "";
        this.StaffName = "";
        this.Dept = "";
        this.Title = "";
        this.YOS = "";
        this.DateJoin = moment("1900-01-01").format(Settings.DateTime.yyyymmdd);
        this.LastWorkingDate = moment("1900-01-01").format(Settings.DateTime.yyyymmdd);
        this.AnnualLeave = "";
        this.CompensationLeave = "";
        this.AnnualLeaveTotal = 0;
        this.CompensationLeaveTotal = 0;
        this.AnnualLeaveMEP = "";
        this.CompensationLeaveMEP = "";
        this.EmployType = "";
        this.PayType = "";
        this.Salary = 0;
        this.AtuSalary = 0;
        this.DailyRate = 0;
        this.LessMPF = 0;
        this.salaryAdjs = [];
    }
}



// WEBPACK FOOTER //
// ./src/model/FinalPayment.js